<script setup>
import { useStore } from '@admin_js/store'
import SlideOver from '@admin_ui/Components/Common/Filters/SlideOver'
import { Inertia } from '@inertiajs/inertia'
import Inline from './Inline.vue'

const store = useStore()

const filter = () => {
  let queryParam = route().params
  let filters = {}
  store.getFilters().forEach((filter) => {
    if (filter.value) {
      filters[filter.field] = filter.value
    }
  })

  Inertia.get(route(route().current(), { ...queryParam, filters }))
}
</script>

<template>
  <div v-if="store.resource && store.resourceHasFilters()">
    <Inline v-if="store.showFiltersInline()" @filter="filter" />
    <SlideOver v-else @filter="filter" />
  </div>
</template>
